import React from "react";
import {
  TextField,
  InputAdornment,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const VehicleDrawerFilters = ({
  theme,
  mode,
  isSearchOpen,
  searchTerm,
  vehicleType,
  includeInactive,
  selectedVehiclesCount,
  isLoading,
  onSearch,
  onVehicleTypeChange,
  onIncludeInactiveChange,
  onAssignVehicles,
}) => (
  <div className={`GM__${theme}-vehicle-drawer-filters`}>
    {isSearchOpen && (
      <div className={`GM__${theme}-search-container`}>
        <TextField
          id="vehicle-search-input"
          fullWidth
          variant="outlined"
          placeholder="Buscar por placa, tipo..."
          value={searchTerm}
          onChange={onSearch}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            className: `GM__${theme}-search-input`,
          }}
        />
      </div>
    )}

    <div className={`GM__${theme}-filters-row`}>
      <FormControl
        variant="outlined"
        size="small"
        className={`GM__${theme}-vehicle-type-filter`}
      >
        <InputLabel>Tipo de vehículo</InputLabel>
        <Select
          value={vehicleType}
          onChange={onVehicleTypeChange}
          label="Tipo de vehículo"
        >
          <MenuItem value="all">Todos</MenuItem>
          <MenuItem value="vehicles">Solo vehículos</MenuItem>
          <MenuItem value="combined">Solo combinaciones</MenuItem>
        </Select>
      </FormControl>

      <FormControlLabel
        control={
          <Checkbox
            checked={includeInactive}
            onChange={onIncludeInactiveChange}
          />
        }
        label="Incluir inactivos"
        className={`GM__${theme}-inactive-filter`}
      />

      {mode === "add" && selectedVehiclesCount > 0 && (
        <button
          className={`GM__${theme}-assign-vehicle-btn`}
          onClick={onAssignVehicles}
          disabled={isLoading}
        >
          <span>Asignar {selectedVehiclesCount}</span>
        </button>
      )}
    </div>
  </div>
);

export default React.memo(VehicleDrawerFilters);